import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleDropdown = (section) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <footer className="apple-footer">
      <div className="footer-container">
        {/* Footer Logo */}
        <div className="footer-logo-section">
          <img 
            src="/logo/Only logo in Black-1.webp" 
            alt="Dvi Studios Logo" 
            className="footer-logo"
          />
        </div>

        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-column">
            <button 
              className="footer-dropdown-toggle"
              onClick={() => toggleDropdown('services')}
              aria-expanded={openDropdowns.services}
            >
              <h3>Services</h3>
              <span className={`dropdown-arrow ${openDropdowns.services ? 'open' : ''}`}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6,9 12,15 18,9"/>
                </svg>
              </span>
            </button>
            <ul className={`footer-links ${openDropdowns.services ? 'open' : ''}`}>
              <li><Link to="/photo-videography">Photography & Videography</Link></li>
              <li><Link to="/pre-post-wedding">Pre & Post Wedding</Link></li>
              <li><Link to="/fashion-shoot">Fashion Shoots</Link></li>
              <li><Link to="/corporate-events">Corporate Events</Link></li>
              <li><Link to="/baby-shoots">Baby Shoots</Link></li>
              <li><Link to="/ads">Advertising Photography</Link></li>
              <li><Link to="/podcast">Podcast Production</Link></li>
              <li><Link to="/film-making">Film Making</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <button 
              className="footer-dropdown-toggle"
              onClick={() => toggleDropdown('company')}
              aria-expanded={openDropdowns.company}
            >
              <h3>Company</h3>
              <span className={`dropdown-arrow ${openDropdowns.company ? 'open' : ''}`}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6,9 12,15 18,9"/>
                </svg>
              </span>
            </button>
            <ul className={`footer-links ${openDropdowns.company ? 'open' : ''}`}>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <button 
              className="footer-dropdown-toggle"
              onClick={() => toggleDropdown('follow')}
              aria-expanded={openDropdowns.follow}
            >
              <h3>Follow Us</h3>
              <span className={`dropdown-arrow ${openDropdowns.follow ? 'open' : ''}`}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6,9 12,15 18,9"/>
                </svg>
              </span>
            </button>
            <ul className={`footer-links ${openDropdowns.follow ? 'open' : ''}`}>
              <li>
                <a href="https://www.instagram.com/dvi.studios" target="_blank" rel="noopener noreferrer" className="social-link">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                  <span>Instagram</span>
                </a>
              </li>
              <li>
                <a href="#" target="_blank" rel="noopener noreferrer" className="social-link">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  <span>Facebook</span>
                </a>
              </li>
              <li>
                <a href="#" target="_blank" rel="noopener noreferrer" className="social-link">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                  </svg>
                  <span>Twitter</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Section - Always Open on Mobile */}
          <div className="footer-column footer-contact-mobile">
            <h3>Contact</h3>
            <ul className="footer-links contact-links-mobile">
              <li><a href="mailto:dvistudios25@gmail.com">dvistudios25@gmail.com</a></li>
              <li><a href="tel:+919347821691">+91 9347821691</a></li>
              <li>Hyderabad, India</li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>Copyright © 2025 Dvi Studios. All rights reserved.</p>
              <p className="developer-credit">Designed and developed by <a href="https://octaleads.com" target="_blank" rel="noopener noreferrer">Octaleads Pvt Ltd</a></p>
            </div>
            <div className="footer-legal">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Use</Link>
              <Link to="/cookies">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
